export const LANGUAGES_SKILL = ["TypeScript", "JS", "Java", "SQL", "CSS", "HTML", "Go", "PHP"] as const;
export const FRAMEWORKS_SKILL = ["Nextjs", "ReactJs", "SpringBoot", "ExpressJs", "Jest"] as const;
export const TOOLS_SKILL = [
  { label: "VScode", icon: "vscode" },
  { label: "IntelliJ IDEA", icon: "intellij" },
  { label: "DataGrip", icon: "datagrip" },
  { label: "DBeaver", icon: "dbeaver" },
  { label: "Postman", icon: "postman" },
  { label: "Jira", icon: "jira" },
] as const;
